import { gql } from '@apollo/client';

export const UPDATE_AMBIENT_MONITOR = gql`
    mutation UpdateAmbientMonitor($id: Guid!, $input: UpdateAmbientMonitor!) {
        facility {
            process {
                updateAmbientMonitor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
